<template>
  <b-card-code title="All Projects">
    <!-- <button
      v-if="this.$store.state.app.user.is_staff"
      type="button"
      class="btn ml-auto btn-primary m-1"
    >
       <router-link class="text-white" :to="'/owasp/add'">Add New</router-link>
    </button> -->
    <!-- Search Function -->
    <b-card-code class="bg-light-secondary mb-1" title="Search">
      <b-form inline style="display: inline-block; width: 100%">
        <div class="row" style="width: 100%; padding: 5px">
          <b-form-select
            class="ml-1"
            style="width: 30%"
            v-if="is_staff"
            @change="load(true)"
            v-model="organization"
            :options="organizations"
          >
          </b-form-select>
          <b-form-input
            class="ml-1"
            id="name_filter"
            v-model="name_filter"
            style="width: 40%"
            name="name_filter"
            placeholder="Search with Name"
          />
          <!-- <b-form-select
              class="ml-1"
              style="width: 25%"
              v-model="type_filter"
              :options="type_filter_options"
            >
            </b-form-select> -->
          <b-button
            style="width: 20%"
            class="ml-1"
            variant="primary"
            @click="load(true)"
          >
            Search
          </b-button>
        </div>
      </b-form>
    </b-card-code>
    <!-- End of search form -->
    <b-table
      responsive
      id="cvdTable"
      :fields="computedFields"
      :items="items"
      :per-page="perPage"
    >
      <template #cell(index)="data">
        {{ data.index + 1 + perPage * (currentPage - 1) }}
      </template>
      <template #cell(project_name)="data">
        <router-link
          :to="
            '/all-documents?project_id=' +
            data.item.project_id +
            '&project_name=' +
            data.item.project_name
          "
          >{{ data.item.project_name }}</router-link
        >
      </template>
      <template #cell(created_at)="data">
        {{ data.item.created_at | formatdate }}
      </template>
      <!-- <template #cell(is_reviewed)="data">
        <b-badge variant="danger" v-if="!data.item.is_reviewed">No</b-badge>
        <b-badge variant="success" v-else>Yes</b-badge>

      </template> -->
      <template #cell(actions)="data">
        <!-- <button @click="editOrg(data.item.org_id)" type="button" class="btn btn-primary btn-sm mr-1" style="position: relative;"> Edit</button>
        <button @click="deleteOrg(data.item.org_id)" type="button" class="btn btn-danger btn-sm mr-1" style="position: relative;"> Delete </button> -->
        <b-dropdown
          size="sm"
          class="ml-1"
          variant="outline-primary"
          text="Actions"
        >
          <b-dropdown-item @click="editProject(data.item.project_id)"
            >Edit</b-dropdown-item
          >

          <!-- <b-dropdown-item @click="allocateScanners(data.item.org_id)">Default Scanners</b-dropdown-item>  -->
          <b-dropdown-divider />
          <b-dropdown-item @click="deleteProject(data.item.project_id)"
            >Delete</b-dropdown-item
          >
        </b-dropdown>
      </template>
    </b-table>

    <b-pagination-nav
      v-model="currentPage"
      :numberOfPages="total"
      :link-gen="linkGen"
      :total-rows="rows"
      :per-page="perPage"
      :align="pagination_pos"
      aria-controls="cvdTable"
      use-router
    />
  </b-card-code>
</template>

<script>
import BCardCode from "@core/components/b-card-code/BCardCode.vue";
import { BTable } from "bootstrap-vue";
import {
  BPagination,
  BPaginationNav,
  BButton,
  BDropdown,
  BDropdownItem,
  BDropdownDivider,
  BForm,
  BFormInput,
  BBadge,
  BFormSelect,
} from "bootstrap-vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import moment from "moment";

export default {
  components: {
    BCardCode,
    BTable,
    BPagination,
    BPaginationNav,
    BButton,
    BDropdown,
    BDropdownItem,
    BDropdownDivider,
    BForm,
    BFormInput,
    BBadge,
    BFormSelect,
  },
  data() {
    return {
      pagination_pos: "center",
      // Call orgaization API and return in this format
      items: [],
      currentPage: 1,
      perPage: 10,
      rows: 0,
      total: 1,
      is_staff: this.$store.state.app.user.is_staff,
      fields: [
        // { key: "project_id", label: "ID" },
        { key: "index", label: "#" },
        { key: "project_name", label: "Project Name" },
        { key: "created_at", label: "Uploaded At" },
        { key: "added_by", label: "Added BY" },
        { key: "added_from", label: "Added From", requiresAdmin: true },
        { key: "actions", label: "Actions",requiresAdmin: true, },
      ],
      name_filter: "",
      organization: null,
      organizations: [{ value: null, text: "--Select Organization--" }],
      // type_filter: null,
      // type_filter_options: [
      //   { value: null, text: "--Select Type--" },
      //   { value: "web", text: "Web Application" },
      //   { value: "mobile", text: "Mobile Application" },
      //   { value: "api", text: "API" },
      // ],
    };
  },
  computed: {
    computedFields() {
      // If the user isn't an admin, filter out fields that require auth.
      if (!this.is_staff)
        return this.fields.filter((field) => !field.requiresAdmin);
      // If the user IS an admin, return all fields.
      else return this.fields;
    },
  },
  filters: {
    formatdate: function (value) {
      if (value) {
        return moment(String(value)).format("DD-MM-YYYY hh:mm A");
      }
    },
  },
  watch: {
    currentPage: function (newVal, oldVal) {
      this.load();
    },
  },
  created: function () {
    this.load();
     this.loadOrg();
  },
  methods: {
    linkGen: function (pageNum) {
      return this.$router.currentRoute.path + "?page=" + pageNum;
    },
    loadOrg: function () {
      if (this.is_staff) {
        this.loading = true;
        // Load oragnization drop down
        const o_options = {
          method: "GET",
          headers: { "content-type": "application/json" },
          url:
            process.env.VUE_APP_BASEURL +
            "organization/organization",
        };
        var self = this;
        this.$http(o_options).then((res) => {
          // console.log(res.data)
          res.data.map(function (value, key) {
            let org = {
              value: res.data[key].org_id,
              text: res.data[key].org_name,
            };
            // console.log(res.data[key].profile.organization)
            self.organizations.push(org);
          });
          this.loading = false;
        });
      } else {
        this.organization = this.$store.state.app.user.profile.organization;
        this.searchFn();
      }
    },
    load: function (search = false) {
      let url =
        process.env.VUE_APP_BASEURL + "client/project/projects?query=true";
      if (this.$route.query.page && !search) {
        this.currentPage = this.$route.query.page;
        url = url + "&page=" + this.currentPage;
      }
      if (search) url = url + "&page=1";

      if (this.name_filter) {
        if (search) url = url + "&name=" + this.name_filter;
        // this.currentPage = 1
      }
      if (this.organization) {
        if (search) url = url + "&org_id=" + this.organization;
        // this.currentPage = 1
      }
      const options = {
        method: "GET",
        headers: { "content-type": "application/json" },
        url: url,
      };
      this.$http(options).then((res) => {
        console.log(res.data);
        // this.toastMessage(res)  // method call to method2
        this.items = res.data.results;
        this.rows = res.data.length;
        this.total = Math.ceil(res.data.count / this.perPage);
        //   this.currentPage = 1
        //   this.perPage = 10
        //   this.rows = res.data.count
      });
    },

    editProject(id) {
      this.$router.push({ name: "project_edit", params: { id: id } });
    },
    deleteProject(id) {
      if (confirm("This action will also delete all files uploaded in this project. Do you really want to proceed?")) {
        const options = {
          method: "DELETE",
          headers: { "content-type": "application/json" },
          url: process.env.VUE_APP_BASEURL+'client/project/projects/'+ id + "/",
        };
        this.$http(options).then((res) => {
          console.log(res);
          this.load();
          //if(res.data.org_id){
          // this.$router.push({name: 'Organizations'});
          // }
        });
      }
    },
  },
};
</script>
